import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AuthProvider from "./components/AuthProvider/AuthProvider";
import { BrowserRouter as Router } from "react-router-dom";
import { SocketProvider } from "./context/SocketContext";
import { CentrifugeProvider } from "./context/CentrifugeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<AuthProvider>
			<SocketProvider>
				<CentrifugeProvider>
					<Router>
						<App />
					</Router>
				</CentrifugeProvider>
			</SocketProvider>
		</AuthProvider>
	</React.StrictMode>,
);
